// extracted by mini-css-extract-plugin
module.exports = {"widget":"QuickBookingArticleD_widget__Rftyb","link":"QuickBookingArticleD_link__x6xaL","schedule":"QuickBookingArticleD_schedule__CxCvD","dots":"QuickBookingArticleD_dots__C7PKI"};